
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles",
      function () {
        return require("private-next-pages/articles.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles"])
      });
    }
  